import React from "react";

const DollarSign24 = ({ fill = "#172B85", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.75024 15.3888H3.75974L2.2671 9.61176C2.19625 9.34602 2.04583 9.11109 1.82455 9.00036C1.27233 8.7221 0.663826 8.50065 0 8.38896V8.16654H3.20655C3.6491 8.16654 3.98101 8.50065 4.03633 8.88867L4.81079 13.0558L6.80033 8.16654H8.73552L5.75024 15.3888ZM9.84189 15.3888H7.96202L9.50998 8.16654H11.3898L9.84189 15.3888ZM13.8219 10.1673C13.8772 9.77836 14.2092 9.55595 14.5964 9.55595C15.2049 9.5001 15.8678 9.61179 16.4209 9.88909L16.7529 8.3341C16.1997 8.11169 15.5912 8 15.0389 8C13.2144 8 11.8867 9.00039 11.8867 10.3888C11.8867 11.445 12.8272 11.9996 13.491 12.3337C14.2092 12.6669 14.4858 12.8893 14.4304 13.2224C14.4304 13.7221 13.8772 13.9446 13.325 13.9446C12.6612 13.9446 11.9974 13.778 11.3898 13.4997L11.0579 15.0557C11.7218 15.333 12.4399 15.4447 13.1038 15.4447C15.1496 15.4995 16.4209 14.5001 16.4209 13C16.4209 11.1109 13.8219 11.0002 13.8219 10.1673ZM23 15.3888L21.5074 8.16654H19.9041C19.5722 8.16654 19.2403 8.38896 19.1297 8.7221L16.3657 15.3888H18.3009L18.6871 14.3335H21.0649L21.2861 15.3888H23ZM20.1806 10.1115L20.7329 12.8334H19.1849L20.1806 10.1115Z"
      fill={fill}
    />
  </svg>
);

export default DollarSign24;
